// extracted by mini-css-extract-plugin
export var mainContent = "p_bd";
export var mainContentWithGlobal = "p_bf";
export var rootPath = "p_bc";
export var skeletonMenuContainer = "p_bg";
export var skeletonRow = "p_0";